import axios from 'axios';
import { axiosInstance } from './axiosService';
import { endImpersonation, getHandoffCode, startImpersonationTab } from './impersonationSession';
import { constants } from '../common/constants/constants';
import {
    IMPERSONATION_API,
    IMPERSONATION_END_REASONS,
    IMPERSONATION_ERROR_CODES,
} from '../common/constants/impersonation';

// The exchange is public: a bare instance without the app's interceptors, so no stored token is ever attached and a
// refused code is never answered with a token refresh.
export const handoffAxios = axios.create({
    baseURL: `${constants.API_BASE_URL}`,
});

// the code is single-use: a second mount of the handoff page must reuse the first exchange, not burn the code again
let redeemPromise = null;

const exchangeHandoffCode = async () => {
    const code = getHandoffCode();

    if (!code) {
        // a link without a code is answered like a refused one
        const error = new Error('The impersonation link has no code.');
        error.response = { status: 400, data: { code: IMPERSONATION_ERROR_CODES.HANDOFF_INVALID } };
        throw error;
    }

    const { data } = await handoffAxios.post(IMPERSONATION_API.EXCHANGE, { code });
    startImpersonationTab(data);

    return data;
};

export const redeemHandoff = () => {
    if (!redeemPromise) {
        redeemPromise = exchangeHandoffCode();
    }

    return redeemPromise;
};

/** Ends the session on the server (best effort: it may already be over), then leaves the tab. */
export const stopImpersonation = async () => {
    try {
        await axiosInstance.post(IMPERSONATION_API.STOP);
    } catch (error) {
        // the tab ends either way; the server also expires the session on its own
    }

    endImpersonation(IMPERSONATION_END_REASONS.STOPPED);
};
